var map = {
	"./logo-med2.png": "8d8c",
	"./logo_arch.png": "4373",
	"./logo_boi.png": "286a",
	"./logo_chiangmairam.png": "a991",
	"./logo_chivacare.png": "6c2d",
	"./logo_cm.png": "12e7",
	"./logo_cm_co.png": "163c",
	"./logo_cmex.png": "9dfc",
	"./logo_cmneuro.png": "c7f8",
	"./logo_dent.png": "6999",
	"./logo_entaneer.png": "b855",
	"./logo_hokankr.png": "e61c",
	"./logo_med.png": "6326",
	"./logo_med2.png": "340d",
	"./logo_medtech.png": "dda1",
	"./logo_nakorncm.png": "78f1",
	"./logo_nia.png": "4f81",
	"./logo_nst.png": "5e63",
	"./logo_nstda.png": "49c1",
	"./logo_nursing.png": "4986",
	"./logo_pharmacy.png": "26bb",
	"./logo_publichealth.png": "2298",
	"./logo_punspace.png": "d6a9",
	"./logo_sapar.png": "74f8",
	"./logo_step.png": "565d",
	"./logo_tcels.png": "5d16",
	"./mhesi.png": "41a6",
	"./nia12.png": "0d66"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b57";